import { extractBaseDomain } from "./domain";

import { domains } from "@/sites/domains";

import type { SiteInfo, DomainRouteConfig } from "@/sites/types";

export const getSiteUrl = () => {
  return `${process.env.NEXT_PUBLIC_HTTP_PROTOCOL}://${process.env.NEXT_PUBLIC_DOMAIN}`;
};

// Get only the domain name. https://fceb876b1.qrcreator.com/pricing?utm=google  -> qrcreator.com
export const getSiteDomain = () => {
  const siteUrl = getSiteUrl();
  const parsedUrl = new URL(siteUrl);
  let domain = extractBaseDomain(parsedUrl.hostname);

  // If it is localhost, get the domain name with the theme equal to NEXT_PUBLIC_THEME
  if (domain === "localhost") {
    const theme = process.env.NEXT_PUBLIC_THEME;
    const targetDomainInfo = Object.values(domains).find(
      (domain): domain is SiteInfo => (domain as SiteInfo).siteTheme === theme
    );

    domain = targetDomainInfo?.domainName || "localhost";
  }

  return domain;
};

export const getLogoHref = (domainConfig?: DomainRouteConfig): string | undefined => {
  if (!domainConfig?.logoLinkEnabled) return undefined;

  return domainConfig.seoSiteUrl || "/";
};
